export const serviceTypeConstants = {
    SERVICETYPE_SUCCESS: 'SERVICETYPE_SUCCESS',
}